import { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import {
  setArticleBountyBoardRenderer,
  TArticleBountyBoardProps
} from '../../../../../shared/frontend/libs/articleBountyBoardRenderer';
import { TRouter } from '../../../../../shared/frontend/libs/router/types';
import { ArticleInjectionRouter } from './registerArticlePremiumPerksRenderer';

const BountyBoard = lazy(() =>
  import('../components/container/bounties/BountyBoard').then(({ BountyBoard: Component }) => ({
    default: Component
  }))
);

export function registerArticleBountyBoardRenderer(store: any, router: TRouter) {
  setArticleBountyBoardRenderer((props: TArticleBountyBoardProps) => (
    <Provider store={store}>
      <ArticleInjectionRouter router={router}>
        <Suspense fallback={null}>
          <BountyBoard eventSlug={props.eventSlug} bountySlug={props.bountySlug} compact={props.compact} />
        </Suspense>
      </ArticleInjectionRouter>
    </Provider>
  ));
}
